// extracted by mini-css-extract-plugin
export default {"Assistance":"Assistance_Assistance__ZDicT","para":"Assistance_para__T0eY3","list":"Assistance_list__DuBwA","view-more":"Assistance_view-more__uUl-p"};